import { useEffect } from 'react';

/**
 * JsonLd — injects one or more JSON-LD objects into <head> imperatively
 * (the prod crawler-prerenderer reliably captures imperative head tags).
 * Use this for structured data that is NOT tied to the page-level <Seo>
 * (title/canonical/robots) — e.g. ItemLists for curated home-page sections.
 */
const JsonLd = ({ data = [] }) => {
  const serialized = JSON.stringify(
    Array.isArray(data) ? data.filter(Boolean) : (data ? [data] : [])
  );

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const list = JSON.parse(serialized);
    const nodes = list.map((obj) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.setAttribute('data-jsonld', 'true');
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });
    return () => nodes.forEach((n) => n.remove());
  }, [serialized]);

  return null;
};

export default JsonLd;
